import React from 'react'
import SAISVG from '../../../../../../../_template/helpers/CommonFunction';
const PriceModuleList = (props) => {
    const {data} = props;
    return (
        <tr>
            <td>
                {data.module_name}
            </td>
            <td>
                {data.price} {data.price_type}
            </td>
            <td>
                {data.includes}
            </td>
            <td className='text-end'>
                <button 
                    className="btn btn-sm btn-icon btn-light-primary me-3 px-4"
                    onClick={() => (
                        props.updatePriceModuleOnClick({
                            id: data.id,
                        })
                    )}
                >
                    <SAISVG path="media/icons/duotune/art/art005.svg" className="svg-icon-muted svg-icon-2" />
                </button>
                <button 
                    className="btn btn-sm btn-icon btn-light-danger px-4"
                    onClick={() => (
                        props.deletePriceModuleOnClick({
                            id: data.id,
                        })
                    )}
                > 
                    <SAISVG path="media/icons/duotune/general/gen027.svg" className="svg-icon-muted svg-icon-2" />
                </button>
            </td>
        </tr>
    )
}

export default PriceModuleList